var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPricingIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 68,
    viewBox: "0 0 78 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.224 48.3273L59.6348 58.4824L26.0263 39.0819L43.6155 28.9268L77.224 48.3273Z",
    fill: "#D6E1FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.0675 26.4873L73.5639 56.216L55.5161 66.9998L49.5742 67.0002L4.24023 40.8121L22.0675 26.4873Z",
    fill: "#E0EFEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17773 15.7168L2.17879 29.7441C2.17884 30.373 2.5144 30.9541 3.05906 31.2686L12.4929 36.7152",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52152 14.087L3.51307 20.2584C3.51307 20.4566 3.3838 20.6548 3.12531 20.8013C2.60828 21.1029 1.75521 21.1029 1.23818 20.8013C0.971063 20.6462 0.841797 20.448 0.841797 20.2498L0.850289 14.0784C0.850289 14.2766 0.979515 14.4748 1.24663 14.6299C1.77229 14.9314 2.61673 14.9314 3.13376 14.6299C3.39225 14.4833 3.52152 14.2851 3.52152 14.087Z",
    fill: "#00CB98",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50695 20.2617L3.5154 14.0916C3.51487 14.2893 3.3856 14.487 3.12764 14.6332C2.95427 14.7343 2.74411 14.8015 2.52148 14.8348V21.0047C2.74124 20.9709 2.94851 20.9042 3.11919 20.8046C3.37768 20.6581 3.50695 20.4599 3.50695 20.2617Z",
    fill: "#00CB98"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52152 14.087L3.51307 20.2584C3.51307 20.4566 3.3838 20.6548 3.12531 20.8013C2.60828 21.1029 1.75521 21.1029 1.23818 20.8013C0.971063 20.6462 0.841797 20.448 0.841797 20.2498L0.850289 14.0784C0.850289 14.2766 0.979515 14.4748 1.24663 14.6299C1.77229 14.9314 2.61673 14.9314 3.13376 14.6299C3.39225 14.4833 3.52152 14.2851 3.52152 14.087Z",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1234 13.5395C3.64905 13.841 3.64905 14.3322 3.13202 14.6338C2.615 14.9354 1.76192 14.9354 1.2449 14.6338C0.719285 14.3322 0.719288 13.841 1.23632 13.5395C1.7533 13.2378 2.59779 13.2378 3.1234 13.5395Z",
    fill: "#38C076",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18359 14.124V12.1362",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53906 12.1411L8.54012 26.1684C8.54021 26.7973 8.87572 27.3784 9.42061 27.6929L18.8545 33.1396",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5039 8.52271L14.5048 22.55C14.5052 23.1789 14.8406 23.76 15.3851 24.0745L24.8189 29.5212",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8397 6.90511L15.8313 13.0766C15.8313 13.2747 15.7019 13.4729 15.4436 13.6194C14.9264 13.921 14.0734 13.921 13.5563 13.6194C13.2896 13.4643 13.1602 13.2661 13.1602 13.0679L13.1685 6.89648C13.1685 7.09468 13.2979 7.29287 13.5651 7.44797C14.0906 7.74956 14.9352 7.74956 15.4519 7.44797C15.7107 7.3015 15.8397 7.1033 15.8397 6.90511Z",
    fill: "#F8D555",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8253 13.0764L15.8337 6.90625C15.8332 7.104 15.7038 7.30167 15.4459 7.44784C15.2725 7.54898 15.0626 7.61619 14.8398 7.64951V13.8194C15.0595 13.7855 15.2668 13.7189 15.4375 13.6193C15.6959 13.4728 15.8253 13.2746 15.8253 13.0764Z",
    fill: "#F8D555"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8397 6.90511L15.8313 13.0766C15.8313 13.2747 15.7019 13.4729 15.4436 13.6194C14.9264 13.921 14.0734 13.921 13.5563 13.6194C13.2896 13.4643 13.1602 13.2661 13.1602 13.0679L13.1685 6.89648C13.1685 7.09468 13.2979 7.29287 13.5651 7.44797C14.0906 7.74956 14.9352 7.74956 15.4519 7.44797C15.7107 7.3015 15.8397 7.1033 15.8397 6.90511Z",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.442 6.35216C15.9676 6.65374 15.9676 7.14494 15.4504 7.44652C14.9337 7.7481 14.0803 7.7481 13.5635 7.44652C13.0376 7.14494 13.0376 6.65374 13.5547 6.35216C14.0719 6.05058 14.9161 6.05058 15.442 6.35216Z",
    fill: "#FFED8C",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5039 6.95776V4.96997",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88658 9.82694L9.87822 15.9984C9.87822 16.1966 9.74882 16.3948 9.49046 16.5413C8.97352 16.8429 8.1204 16.8429 7.60342 16.5413C7.3363 16.3862 7.20703 16.188 7.20703 15.9898L7.21548 9.81836C7.21548 10.0166 7.34475 10.2147 7.61187 10.3698C8.13748 10.6714 8.98197 10.6714 9.49882 10.3698C9.75762 10.2233 9.88658 10.0251 9.88658 9.82694Z",
    fill: "#0e131c",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.874 15.9985L9.88237 9.82837C9.88193 10.0261 9.75297 10.2238 9.49461 10.37C9.32163 10.4711 9.11129 10.5383 8.88867 10.5716V16.7415C9.10839 16.7077 9.31547 16.641 9.48625 16.5414C9.74505 16.3949 9.874 16.1967 9.874 15.9985Z",
    fill: "#0e131c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88658 9.82694L9.87822 15.9984C9.87822 16.1966 9.74882 16.3948 9.49046 16.5413C8.97352 16.8429 8.1204 16.8429 7.60342 16.5413C7.3363 16.3862 7.20703 16.188 7.20703 15.9898L7.21548 9.81836C7.21548 10.0166 7.34475 10.2147 7.61187 10.3698C8.13748 10.6714 8.98197 10.6714 9.49882 10.3698C9.75762 10.2233 9.88658 10.0251 9.88658 9.82694Z",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49071 9.27428C10.0162 9.57591 10.0162 10.0671 9.49907 10.3686C8.98222 10.6702 8.12915 10.6702 7.61212 10.3686C7.08647 10.0671 7.08647 9.57591 7.6035 9.27428C8.12052 8.9727 8.96497 8.9727 9.49071 9.27428Z",
    fill: "#3BCFF0",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55273 9.82767V7.83984",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2124 48.77L23.6539 22.469L3.98828 33.8219L3.98876 40.6949L49.5475 66.9961L69.2132 55.6432L69.2124 48.77Z",
    fill: "#0e131c",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5437 37.4191L23.65 22.4707L3.98438 33.8237L3.98486 40.6967L49.5437 66.9978V37.4191Z",
    fill: "#0e131c",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2091 48.7717L23.6504 22.4707L3.98481 33.8236L49.5435 60.1247L69.2091 48.7717Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2091 48.7717L23.6504 22.4707L3.98481 33.8236L49.5435 60.1247L69.2091 48.7717Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7619 52.6596L17.25 30.4268L7.67471 35.9546L46.1866 58.1875L55.7619 52.6596Z",
    fill: "#E0EFEC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6498 22.469L69.2087 48.77L49.543 60.1229L3.98438 33.822L23.6498 22.469Z",
    fill: "white",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M64.709 46.2919L54.0078 52.4702L20.3994 33.0697L31.1005 26.8914L64.709 46.2919Z",
    fill: "#D6E1FB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9284 1.98462L18.8496 34.0577L52.3396 53.3802L52.4575 21.3072L18.9284 1.98462Z",
    fill: "white",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9277 1.98462V5.46609L52.4569 24.7814V21.3072L18.9277 1.98462Z",
    fill: "#D6E1FB",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3379 53.3814L54.0298 52.4368L54.1086 20.3638L52.4558 21.3083L52.3379 53.3814Z",
    fill: "#E1FDFF",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1121 23.7555V20.3638L52.4492 21.322V24.7133L54.1121 23.7555Z",
    fill: "#BBE1D8",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4569 21.3064L54.1096 20.3619L20.6201 1L18.9277 1.98384L52.4569 21.3064Z",
    fill: "white",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5087 7.89259C24.032 7.88132 23.6548 7.48577 23.6663 7.0091C23.6773 6.53248 24.073 6.1552 24.5496 6.16651C25.0263 6.17778 25.4035 6.57328 25.392 7.04995C25.381 7.52657 24.9854 7.90386 24.5087 7.89259Z",
    fill: "white",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1299 7.29485C24.5612 7.30507 24.9622 6.96128 24.9732 6.49051C24.9749 6.41207 24.9767 6.3336 24.9384 6.29346C25.2095 6.45684 25.3992 6.7361 25.3917 7.04992C25.3807 7.52069 24.9789 7.90369 24.5084 7.89256C24.0766 7.88235 23.7703 7.56109 23.7012 7.16695C23.8169 7.2482 23.9732 7.29116 24.1299 7.29485Z",
    fill: "#D1D1D1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5087 7.89259C24.032 7.88132 23.6548 7.48577 23.6663 7.0091C23.6773 6.53248 24.073 6.1552 24.5496 6.16651C25.0263 6.17778 25.4035 6.57328 25.392 7.04995C25.381 7.52657 24.9854 7.90386 24.5087 7.89259Z",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4564 6.70777C21.9797 6.69651 21.6025 6.30096 21.6135 5.82433C21.625 5.34766 22.0206 4.97042 22.4969 4.98169C22.9735 4.99296 23.3512 5.38847 23.3397 5.86513C23.3283 6.3418 22.933 6.71904 22.4564 6.70777Z",
    fill: "white",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0776 6.11004C22.5089 6.12025 22.9094 5.77646 22.9209 5.30569C22.9226 5.22726 22.9244 5.14878 22.8861 5.10864C23.1568 5.27207 23.3465 5.55129 23.339 5.8651C23.328 6.33587 22.9266 6.71888 22.4556 6.70774C22.0243 6.69753 21.718 6.37628 21.6484 5.98214C21.7646 6.06339 21.9204 6.10634 22.0776 6.11004Z",
    fill: "#D1D1D1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4564 6.70777C21.9797 6.69651 21.6025 6.30096 21.6135 5.82433C21.625 5.34766 22.0206 4.97042 22.4969 4.98169C22.9735 4.99296 23.3512 5.38847 23.3397 5.86513C23.3283 6.3418 22.933 6.71904 22.4564 6.70777Z",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4052 5.52468C19.9285 5.51341 19.5513 5.11786 19.5628 4.64122C19.5738 4.16457 19.9694 3.78731 20.4461 3.79859C20.9228 3.80986 21.3 4.20539 21.289 4.68204C21.2775 5.1587 20.8818 5.53594 20.4052 5.52468Z",
    fill: "white",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9853 4.92694C20.4167 4.93715 20.8172 4.59336 20.8286 4.12261C20.8304 4.04415 20.8322 3.9657 20.7939 3.92554C21.065 4.08895 21.2542 4.36819 21.2472 4.68203C21.2358 5.15277 20.8344 5.53578 20.3634 5.52464C19.9321 5.51448 19.6257 5.19322 19.5566 4.79905C19.7116 4.88122 19.8674 4.92416 19.9853 4.92694Z",
    fill: "#D1D1D1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4052 5.52468C19.9285 5.51341 19.5513 5.11786 19.5628 4.64122C19.5738 4.16457 19.9694 3.78731 20.4461 3.79859C20.9228 3.80986 21.3 4.20539 21.289 4.68204C21.2775 5.1587 20.8818 5.53594 20.4052 5.52468Z",
    stroke: "#0e131c",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2703 37.4362L21.7129 34.2273L21.7119 8.55808L27.2694 11.7669L27.2703 37.4362Z",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M32.827 40.6469L27.2695 37.438L27.2686 11.7688L32.826 14.9776L32.827 40.6469Z",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3856 43.8576L32.8281 40.6487L32.8272 14.9795L38.3846 18.1883L38.3856 43.8576Z",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9403 47.0646L38.3828 43.8557L38.3818 18.1865L43.9393 21.3954L43.9403 47.0646Z",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5008 50.2753L43.9434 47.0664L43.9424 21.3972L49.4998 24.6061L49.5008 50.2753Z",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5095 43.8605L49.5098 50.2778L21.7226 34.2335L21.7224 27.8162L49.5095 43.8605Z",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5095 37.4418L49.5098 43.8591L21.7226 27.8148L21.7224 21.3975L49.5095 37.4418Z",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5095 31.0204L49.5098 37.4377L21.7226 21.3934L21.7224 14.9761L49.5095 31.0204Z",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5095 24.6044L49.5098 31.0217L21.7226 14.9774L21.7224 8.56009L49.5095 24.6044Z",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2015 26.3479L25.9531 27.9365L25.9538 36.6583L23.2021 35.0696L23.2015 26.3479Z",
    fill: "#D6E1FB",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7444 23.9006L31.4961 25.4893L31.4972 39.8636L28.7455 38.275L28.7444 23.9006Z",
    fill: "#00CB98",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1566 23.1892L36.9082 24.7778L36.9096 43.0053L34.1579 41.4166L34.1566 23.1892Z",
    fill: "#0e131c",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8402 23.7497L42.5918 25.3384L42.5934 46.1555L39.8417 44.5669L39.8402 23.7497Z",
    fill: "#0e131c",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M45.389 22.2629L48.1406 23.8516L48.1426 49.4055L45.3909 47.8168L45.389 22.2629Z",
    fill: "#F8D555",
    stroke: "#0e131c",
    strokeWidth: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIcon02);
export default __webpack_public_path__ + "static/media/pricing-icon02.176c998d111b12e9cb53ce4c212c8976.svg";
export { ForwardRef as ReactComponent };